import styles from './styles.module.scss';
import Icons from '../../icons';

type NoPromosPropsType = {
  active: boolean;
};

const NoPromos = (props: NoPromosPropsType) => {
  const { active } = props;

  return (
    <div className={styles.noPromos}>
      <Icons variant={Icons.PROMO_BIG} />
      {`No ${active ? 'Active' : 'Inactive'} promos`}
    </div>
  );
};

export default NoPromos;
